import React from 'react';
import clsx from 'clsx';

import styles from './DraggableHTMLWaypoint.module.scss';

interface DraggableHTMLWaypointProps {
  isDragging?: boolean;
}

export const DraggableHTMLWaypoint = ({
  isDragging
}: DraggableHTMLWaypointProps) => {
  return (
    <div
      className={clsx(styles.draggable, isDragging && styles.dragging)}
    ></div>
  );
};
